export default __webpack_public_path__ + "static/doki4-c5593cbead42762f122e3804c4b0fb16.png";